export { View as NewLPScreen } from './view'
